const delayTime = (time: number) => {
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      resolve(true);
      timer && clearTimeout(timer);
    }, time);
  });
};
export default delayTime;
